<style lang="stylus">
.face-portrait::after {
  display: inline-block;
  content: '';
  width: 116px;
  height: 120px;
  border-width: 2px;
  border-style: dashed;
  border-color: #8c1d30;
  border-radius: 70px;
  position: absolute;
  -webkit-transform: translate(-121px, -20px);
  margin: -1.5% 10% 7% 9.6%;
}

.face-portrait-step-1 {
  background-image: url('../assets/icons/Group-9025.png');
  width: 157px;
  height: 189px;
  position: relative;
  top: 32px;
}

.captured-image {
  height: 260px;
  width: 346px;
  margin: 24px;
  margin-bottom: 0;
  cursor: pointer;
}

.contact-card-step-2 {
  background-image: url('../assets/icons/Group-9033.png');
  width: 238px;
  height: 154px;
  position: relative;
  top: 50px;
}

@media (max-width: 600px) {
  .contact-card-step-2 {
    top: 100px;
  }

  .face-portrait-step-1 {
    top: 77px;
  }
}
</style>
<template>
  <div class="image-display-grey-bg grey-bg-take-photo">
    <div class="image-display-face-bg" v-if="firstTime">
      <div class :class="step == 1 ? 'face-portrait-step-1' : ''" />

      <div class :class="step == 2 ? 'contact-card-step-2' : ''" />
    </div>
    <div v-if="!isLiveCameraOn" style="text-align: center">
      <img v-bind:src="imageHighResCaptured" class="captured-image" v-if="imageHighResCaptured" />
    </div>

    <div v-else>
      <video-component v-on:capture="capture($event)" />
    </div>

    <canvas ref="canvas" id="canvas" :style="{ display: displayCanvas }" />
    <canvas ref="highrescapture" style="display: none" :width="windowRes ? 480 : 640" :height="windowRes ? 640 : 480" />

    <div>
      <v-btn
        class="video-icon mt-2"
        @click="
          openCamera();
          asuoDataLayerClick('idVerifiyStep1', '1', {});
        "
        :ripple="false"
        variant="flat"
        color="#8C1D40"
        v-if="!isLiveCameraOn && firstTime"
      >
        <v-icon size="18px" style="padding-right: 6px">mdi-video</v-icon>Use my camera
      </v-btn>
      <v-btn
        class="camera-icon mt-2"
        :ripple="false"
        variant="flat"
        color="#8C1D40"
        v-if="!isLiveCameraOn && !firstTime"
        @click="
          asuoDataLayerClick('idVerifiyStep1', '3', {});
          openCamera();
        "
      >
        <v-icon size="26px" style="margin-right: 6px">mdi-camera</v-icon>&nbsp;Retake
      </v-btn>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useUserStore } from '@/stores/user';

import { DataLayerMixin } from '../mixins/dataLayerMixin.js';
export default defineComponent({
  emits: ['clickedImage', 'retakeImage'],

  data() {
    return {
      windowRes: window.innerHeight > window.innerWidth,
      canvas: {},
      highResCam: {},
      isLiveCameraOn: false,
      imageCaptured: '',
      imageHighResCaptured: '',
      displayCanvas: 'none',
      firstTime: true
    };
  },

  props: {
    step: {
      type: Number
    }
  },

  mixins: [DataLayerMixin],

  methods: {
    capture(event) {
      this.canvas = this.$refs.canvas;

      // High Res Image Object
      this.highResCam = this.$refs.highrescapture;

      // // this.canvas.getContext('2d').drawImage(event.video, 0, 0, this.canvas.width, this.canvas.height);
      const ctx = this.canvas.getContext('2d');

      // ctx.imageSmoothingEnabled = true;
      //   ctx.imageSmoothingQuality = 'high';

      ctx.drawImage(event.video, 0, 0, this.canvas.width, this.canvas.height);

      this.$emit('clickedImage');
      // eslint-disable-next-line no-console

      this.imageCaptured = this.canvas.toDataURL('image/png');
      const userStore = useUserStore();
      this.step == 1 ? userStore.setFaceImage(this.imageCaptured) : userStore.setIDImage(this.imageCaptured);

      // High Res Image Object
      const ctxHighRes = this.highResCam.getContext('2d');
      ctxHighRes.drawImage(event.video, 0, 0, this.highResCam.width, this.highResCam.height);
      this.imageHighResCaptured = this.highResCam.toDataURL('image/png', 0.7);
      this.step == 1
        ? userStore.setHighResFaceImage(this.imageHighResCaptured)
        : userStore.setHighResIDImage(this.imageHighResCaptured);

      // stop playing
      (event.video.srcObject || {}).getTracks().forEach(function (track) {
        track.stop();
      });
      this.isLiveCameraOn = false;
      this.displayCanvas = true;
    },

    async openCamera() {
      this.$emit('retakeImage');
      this.firstTime = false;
      this.isLiveCameraOn = true;

      this.displayCanvas = false;
    }
  }
});
</script>
